// extracted by mini-css-extract-plugin
export var cardTitle = "_c6-1";
export var commentBubble = "_c6-e";
export var commentForm = "_c6-a";
export var commentInput = "_c6-b";
export var commentLabel = "_c6-d";
export var commentPrompt = "_c6-9";
export var csatCard = "_c6-0";
export var feedbackSection = "_c6-7";
export var starDisabled = "_c6-6";
export var starEmpty = "_c6-5";
export var starFilled = "_c6-4";
export var starWrapper = "_c6-3";
export var starsContainer = "_c6-2";
export var submittedComment = "_c6-c";
export var thankYouText = "_c6-8";